(function ($) {
  $(document).ready(function () {

    const $tables = $(".pricing-table");
    const $images = $(".pricing-table-gallery .wp-block-image");

    if (!$tables.length || !$images.length) return;

    function handleMobileLayout() {
      if ($(window).width() <= 768) {

        $tables.each(function (index) {
          const $table = $(this);

          // prevent duplicate
          if ($table.find(".mobile-image").length) return;

          const $img = $images.eq(index);

          if ($img.length) {
            $img
              .clone()
              .addClass("mobile-image-pricing-table")
              .css("display", "block")
              .insertBefore($table);
          }
        });

      } else {
        $(".mobile-image").remove();
      }
    }

    function updateActiveImage() {
      let scrollTop = $(window).scrollTop();
      let windowHeight = $(window).height();

      $tables.each(function (index) {
        let $table = $(this);
        let offsetTop = $table.offset().top;
        let height = $table.outerHeight();

        if (
          scrollTop + windowHeight / 2 >= offsetTop &&
          scrollTop + windowHeight / 2 < offsetTop + height
        ) {
          $images.hide().eq(index).show();
          return false;
        }
      });
    }
    $images.hide().eq(0).show();

    handleMobileLayout();
    updateActiveImage();

    $(window).on("scroll", function () {
      if ($(window).width() > 768) {
        updateActiveImage();
      }
    });

  });
})(jQuery);